import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-100 border-t border-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className="ri-file-excel-2-line text-lg"></i>
                </div>
                <span className="font-heading text-lg font-bold text-foreground-900">
                  <strong>Itaobuy Spreadsheet</strong> Guide
                </span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                La guida italiana pi&ugrave; completa su Itaobuy Spreadsheet. Recensioni, tutorial, confronti e consigli per utilizzare al meglio questo strumento.
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
                <a href="/" className="hover:text-primary-600 transition-colors cursor-pointer">Link Rapidi</a>
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <a href="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Home</a>
                </li>
                <li>
                  <Link to="/articolo/guida-completa-itaobuy-spreadsheet" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                    Guida Completa
                  </Link>
                </li>
                <li>
                  <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                    Sito Ufficiale
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
                <a href="#categorie" className="hover:text-primary-600 transition-colors cursor-pointer">Categorie</a>
              </h4>
              <ul className="space-y-2.5">
                <li><a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Shoes</a></li>
                <li><a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">T-Shirts</a></li>
                <li><a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Jackets</a></li>
                <li><a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Hoodies / Sweaters</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
                <a href="#contatti" className="hover:text-primary-600 transition-colors cursor-pointer">Info</a>
              </h4>
              <ul className="space-y-2.5">
                <li><a href="/privacy" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Privacy Policy</a></li>
                <li><a href="/cookie" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Cookie Policy</a></li>
                <li><a href="/disclaimer" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Disclaimer</a></li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {currentYear} itaobuyspread.fun - Tutti i diritti riservati. Questo sito &egrave; una guida informativa indipendente.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
            >
              Visita kaspreadsheet.com &rarr;
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}